import { Team, TeamInfo } from '@/services/team'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { ServicePermissionService } from '@/services/service-permission.service'

export interface CreateTeamParams {
  name: string
  scale?: number
}

@Injectable()
export class CreateTeamService {
  constructor (
    private http: Http,
    private team: Team,
    private servicePermission: ServicePermissionService,
  ) {

  }

  async setCurrentTeam (c: TeamInfo) {
    await this.team.updateCurrentTeam(c)
    await this.servicePermission.refreshCurrentTeamPermission()
  }

  createTeam (data: CreateTeamParams) {
    return this.http.post<{
      info: TeamInfo
    }>('/team/create', data)
  }

  checkTeamName (team_name: string) {
    return this.http.post<{ is_exist: boolean }>('/team/team-name/check', { team_name })
  }
}

export {
  TeamInfo
}
